<template>
    <TemplateBuilder :rowProp="dataProp.rowProp" :useForm="dataProp.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
</template>

<script>
import { defineComponent, reactive, defineAsyncComponent } from "vue";
import { initForm } from "./address.logic";

export default defineComponent({
    components: {
        TemplateBuilder: defineAsyncComponent(() => import("../input/template-builder/TemplateBuilder")),
    },
    props: {
        viewOnly: {},
        dataProp: {},
        isLoading: {},
        locale: { default: "" },
        dataKey: { default: "" },
        slots: {},
        menuContext: {},
    },
    emits: ["updateSome", "updateTambon"],
    setup(props, { emit }) {
        const data = reactive({
            rowProp: { gutter: 24 },
            useForm: props.dataProp?.useForm,
            conditionForms: props.dataProp?.conditionForms,
            fieldLogs: props.dataProp?.fieldLogs,
        });
        const refs = reactive({});
        initForm({ props, data, refs, emit });
        return {
            props,
            data,
            refs,
        };
    },
});
</script>
